import { Button, Center, HStack, Link, Text } from 'native-base'
import { Warning } from 'phosphor-react-native'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorImage } from '../images/Error'

type MaintenanceProps = {
  emergencyPhoneNumber: string
}

export const Maintenance: React.FC<MaintenanceProps> = ({ emergencyPhoneNumber }) => {
  const { t } = useTranslation()
  //const emergencyPhoneNumber = 911
  const handleReset = useCallback(() => {
    // TODO: what shall we do here on iOS/Android apps?
    window.location.reload()
  }, [])
  return (
    <Center alignItems="center" minHeight="full">
      <ErrorImage />
      <Text fontSize="xl" bold mt={7}>
        {t('maintenance.heading')}
      </Text>
      <Text fontSize="md" mt={4}>
        {t('maintenance.text')}
      </Text>
      <Button size="sm" mt={5} onPress={handleReset}>
        {t('maintenance.button')}
      </Button>
      <HStack space="1" justifyContent="center" alignItems="center" width="full" mt={7}>
        <Warning size={24} />
        <Text>{t('screens.howCanWeHelp.underLegalAgeModal.emergency', { emergencyPhoneNumber })}</Text>
        <Link href={`tel:${emergencyPhoneNumber}`} _text={{ color: 'primary.500' }}>
          {t('screens.howCanWeHelp.underLegalAgeModal.callEmergency', { emergencyPhoneNumber })}
        </Link>
      </HStack>
    </Center>
  )
}
